import React from 'react';

const EtabsTraining = ({ isVisible, onNavigate, Icons }) => {
    
    const downloadBaseUrl = "https://arkaniomran.ir/Learn-Etabs/";

    // کامپوننت داخلی برای کارت‌های دانلود زیبا
    const DownloadCard = ({ title, subTitle, link, iconType, colorClass, gradientClass }) => (
        <a 
            href={link} 
            download
            className={`group relative overflow-hidden rounded-3xl border border-slate-700 bg-slate-800/50 p-6 transition-all duration-300 hover:border-${colorClass}-500 hover:shadow-2xl hover:shadow-${colorClass}-500/10 hover:-translate-y-2`}
        >
            <div className={`absolute inset-0 bg-gradient-to-br ${gradientClass} opacity-0 transition-opacity duration-300 group-hover:opacity-10`} />
            
            <div className="relative z-10 flex items-center gap-6">
                <div className={`flex h-20 w-20 shrink-0 items-center justify-center rounded-2xl bg-slate-900/80 border border-slate-700 shadow-inner group-hover:scale-110 transition-transform duration-300`}>
                    {iconType === 'etabs' ? (
                        // آیکون انتزاعی سازه برای فایل ایتبس
                        <svg className={`w-10 h-10 text-${colorClass}-500`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                            <path d="M3 21h18M5 21V7l8-4 8 4v14" />
                            <path d="M13 11l-4 2 4 2 4-2-4-2z" />
                            <line x1="13" y1="13" x2="13" y2="21" />
                        </svg>
                    ) : (
                        // آیکون فایل و چرخ دنده برای اکسل و ...
                        <svg className={`w-10 h-10 text-${colorClass}-500`} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                            <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                            <polyline points="14 2 14 8 20 8" />
                            <path d="M12 12v6" />
                            <path d="M9 15h6" />
                        </svg>
                    )}
                </div>
                
                <div className="flex-grow">
                    <h3 className="mb-1 text-xl font-bold text-white group-hover:text-yellow-400 transition-colors">
                        {title}
                    </h3>
                    <p className="text-sm text-slate-400 group-hover:text-slate-300">
                        {subTitle}
                    </p>
                </div>

                <div className={`flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-${colorClass}-500 text-white shadow-lg shadow-${colorClass}-500/30 group-hover:animate-pulse`}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                </div>
            </div>
        </a>
    );

    return (
        <div id="page-etabs-training" className={`page-section ${isVisible ? '' : 'hidden-page'}`}>
            <div className="container mx-auto px-4 py-12 md:py-20">
                
                {/* Header Section */}
                <div className="text-center mb-16 fade-in">
                    <span className="inline-block py-1 px-3 rounded-full bg-red-500/10 border border-red-500/20 text-red-400 text-xs font-bold mb-4 animate-pulse">
                        دوره آموزشی رایگان
                    </span>
                    <h2 className="text-4xl md:text-6xl font-black text-white mb-6 leading-tight">
                        آموزش جامع <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-orange-500">ایتبس فولادی</span>
                    </h2>
                    <p className="text-slate-300 text-lg max-w-3xl mx-auto leading-8">
                        دوره رایگان آموزش نرم‌افزار ETABS ویژه طراحی سازه‌های فولادی، به صورت پروژه‌محور و کاملاً کاربردی از صفر تا صد.
                        در این سری آموزشی، مراحل مدل‌سازی سازه فولادی، تعریف بارگذاری ثقلی و لرزه‌ای بر اساس استاندارد ۲۸۰۰، کنترل تغییرمکان و درصد سختی، طراحی و کنترل مقاطع فولادی و اتصالات، به همراه نکات کاربردی و رایج‌ترین خطاهای مدل‌سازی به‌صورت گام‌به‌گام آموزش داده می‌شود.
                        <br className="hidden md:block" />
                        ویدیوهای آموزشی به مرور در کانال‌های آپارات و یوتیوب بارگذاری می‌شوند و فایل‌های تمرینی هر جلسه در این صفحه قرار می‌گیرند.
                    </p>
                </div>

                {/* Social Links for Videos */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto mb-20 fade-in">
                    <a href="https://www.youtube.com/@arkaniomran" target="_blank" rel="noopener noreferrer" 
                       className="flex items-center justify-center gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 hover:bg-[#FF0000] hover:text-white text-[#FF0000] p-6 rounded-2xl transition-all duration-300 group">
                        <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.376.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136C4.495 20.455 12 20.455 12 20.455s7.505 0 9.376-.505a3.017 3.017 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/></svg>
                        <div className="text-right">
                            <span className="block font-black text-xl">مشاهده در یوتیوب</span>
                            <span className="text-sm opacity-80 group-hover:text-white/90">عضویت در کانال و مشاهده ویدیوها</span>
                        </div>
                    </a>
                    
                    <a href="https://www.aparat.com/playlist/23490785" target="_blank" rel="noopener noreferrer" 
                       className="flex items-center justify-center gap-4 bg-[#EA1D5D]/10 border border-[#EA1D5D]/30 hover:bg-[#EA1D5D] hover:text-white text-[#EA1D5D] p-6 rounded-2xl transition-all duration-300 group">
                        <svg className="w-10 h-10" fill="currentColor" viewBox="0 0 24 24"><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2" fill="none"/><polygon points="10 8 16 12 10 16" fill="currentColor"/></svg>
                        <div className="text-right">
                            <span className="block font-black text-xl">مشاهده در آپارات</span>
                            <span className="text-sm opacity-80 group-hover:text-white/90">دسترسی آسان بدون فیلترشکن</span>
                        </div>
                    </a>
                </div>

                {/* Downloads Section */}
                <div className="mb-20">
                    <div className="flex items-center gap-4 mb-8">
                        <div className="h-1 w-12 bg-yellow-500 rounded-full"></div>
                        <h3 className="text-2xl font-black text-white">فایل‌های تمرینی دوره</h3>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                        {/* فایل پروژه ایتبس */}
                        <DownloadCard 
                            title="فایل پروژه (Etabs Source)"
                            subTitle="فایل مدل‌سازی شده در جلسات آموزشی (آپدیت هفتگی)"
                            link={`${downloadBaseUrl}Learn-EtabsFile.zip`}
                            iconType="etabs"
                            colorClass="sky"
                            gradientClass="from-sky-600/20 to-blue-900/20"
                        />

                        {/* فایل اکسل و جانبی */}
                        <DownloadCard 
                            title="فایل‌های محاسباتی (Excel)"
                            subTitle="شامل اکسل‌های کنترل ضریب زلزله، بارگذاری و ..."
                            link={`${downloadBaseUrl}Excel-Spec-B factor.zip`}
                            iconType="excel"
                            colorClass="emerald"
                            gradientClass="from-emerald-600/20 to-green-900/20"
                        />
                    </div>
                </div>

                {/* Software Info Box */}
                <div className="bg-gradient-to-r from-slate-800 to-slate-900 rounded-3xl p-8 border border-slate-700 relative overflow-hidden">
                    <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-yellow-500 via-purple-500 to-blue-500"></div>
                    
                    <div className="flex flex-col md:flex-row items-center gap-8 relative z-10">
                        <div className="bg-slate-900/50 p-6 rounded-2xl border border-slate-600 text-yellow-500">
                             <Icons.Settings size={48} />
                        </div>
                        
                        <div className="flex-grow text-center md:text-right">
                            <h4 className="text-2xl font-bold text-white mb-3">نرم‌افزارهای مورد نیاز دوره</h4>
                            <p className="text-slate-300 leading-7 mb-4">
                                در این دوره از نرم‌افزارهای تخصصی <span className="text-sky-400 font-bold">SteeliCa</span>، <span className="text-yellow-500 font-bold">BetoniCa</span> و <span className="text-purple-400 font-bold">EtaNex</span> استفاده می‌شود.
                                برای دانلود این ابزارها به بخش <button onClick={() => onNavigate('home', 'products-section')} className="text-yellow-400 underline hover:text-yellow-300">محصولات</button> مراجعه کنید.
                            </p>
                            <div className="bg-slate-900/50 p-4 rounded-xl border border-slate-600/50 inline-block w-full md:w-auto">
                                <p className="text-sm text-slate-400 mb-2">
                                    <span className="text-red-400 font-bold ml-1">توجه:</span>
                                    برای فعال‌سازی و خرید لایسنس به ادمین تلگرام پیام دهید.
                                </p>
                                <p className="text-purple-300 font-bold text-sm bg-purple-500/10 py-1 px-3 rounded-lg border border-purple-500/20">
                                    نرم‌افزار EtaNex فعلاً به صورت رایگان ارائه می‌شود.
                                </p>
                            </div>
                        </div>

                        <a href="https://t.me/arkaniomran" target="_blank" rel="noopener noreferrer" className="bg-blue-600 hover:bg-blue-500 text-white px-8 py-4 rounded-xl font-bold shadow-lg shadow-blue-600/20 transition-all whitespace-nowrap">
                            ارتباط با ادمین
                        </a>
                    </div>
                </div>

                {/* SEO Content Section */}
                <div className="mt-16 max-w-4xl mx-auto text-right">
                    <h3 className="text-xl md:text-2xl font-bold text-white mb-4">درباره دوره آموزش ایتبس فولادی</h3>
                    <p className="text-slate-400 leading-8 mb-4">
                        نرم‌افزار ETABS یکی از پرکاربردترین ابزارهای تحلیل و طراحی سازه در میان مهندسان عمران ایران است. در این دوره آموزش ایتبس فولادی، تلاش شده مسیر یادگیری از تعریف هندسه و مصالح تا تحویل نهایی نقشه‌های سازه فولادی به‌صورت کامل و بدون حذف هیچ مرحله‌ای پوشش داده شود؛ به همین دلیل این آموزش هم برای دانشجویان عمران که می‌خواهند مبانی نرم‌افزار ایتبس را یاد بگیرند و هم برای مهندسان طراح که به دنبال مرور نکات تخصصی طراحی سازه فولادی هستند مناسب است.
                    </p>
                    <p className="text-slate-400 leading-8">
                        در کنار ویدیوهای آموزشی، فایل مدل ایتبس و اکسل‌های کنترلی هر جلسه به‌صورت رایگان در همین صفحه قرار می‌گیرد تا امکان تمرین همراه با آموزش فراهم شود. برای مشاهده سایر دوره‌ها می‌توانید به صفحات <button onClick={() => onNavigate('etabs-concrete-training')} className="text-yellow-400 underline hover:text-yellow-300">آموزش ایتبس بتنی</button>، <button onClick={() => onNavigate('safe-training')} className="text-yellow-400 underline hover:text-yellow-300">آموزش نرم‌افزار SAFE</button> و <button onClick={() => onNavigate('IdeaStatica-training')} className="text-yellow-400 underline hover:text-yellow-300">آموزش IDEA StatiCa</button> مراجعه کنید.
                    </p>
                </div>

            </div>
        </div>
    );
};

export default EtabsTraining;